import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchPlants = createAction(actionTypes.FETCH_PLANTS_REQUEST);
export const fetchPlantsSuccess = createAction(actionTypes.FETCH_PLANTS_SUCCESS);
export const fetchPlantsFailure = createAction(actionTypes.FETCH_PLANTS_FAILURE);

export const fetchAbsences = createAction(actionTypes.FETCH_ABSENCES_REQUEST);
export const fetchAbsencesSuccess = createAction(actionTypes.FETCH_ABSENCES_SUCCESS);
export const fetchAbsencesFailure = createAction(actionTypes.FETCH_ABSENCES_FAILURE);

export const fetchNextAbsences = createAction(actionTypes.FETCH_ABSENCES_NEXT_REQUEST);
export const fetchNextAbsencesSuccess = createAction(actionTypes.FETCH_ABSENCES_NEXT_SUCCESS);
export const fetchNextAbsencesFailure = createAction(actionTypes.FETCH_ABSENCES_NEXT_FAILURE);

export const fetchAbsence = createAction(actionTypes.FETCH_ABSENCE_REQUEST);
export const fetchAbsenceSuccess = createAction(actionTypes.FETCH_ABSENCE_SUCCESS);
export const fetchAbsenceFailure = createAction(actionTypes.FETCH_ABSENCE_FAILURE);

export const addAbsence = createAction(actionTypes.ADD_ABSENCE_REQUEST);
export const addAbsenceSuccess = createAction(actionTypes.ADD_ABSENCE_SUCCESS);
export const addAbsenceFailure = createAction(actionTypes.ADD_ABSENCE_FAILURE);

export const updateAbsence = createAction(actionTypes.UPDATE_ABSENCE_REQUEST);
export const updateAbsenceSuccess = createAction(actionTypes.UPDATE_ABSENCE_SUCCESS);
export const updateAbsenceFailure = createAction(actionTypes.UPDATE_ABSENCE_FAILURE);

export const updateAbsenceId = createAction(actionTypes.UPDATE_ABSENCE_ID);
export const updateProgressIndicator = createAction(actionTypes.UPDATE_PROGRESS_INDICATOR);

export const downloadCSV = createAction(actionTypes.DOWNLOAD_CSV);
export const downloadCSVSuccess = createAction(actionTypes.DOWNLOAD_CSV_SUCCESS);
export const downloadCSVFailure = createAction(actionTypes.DOWNLOAD_CSV_FAILURE);

export const uploadCSV = createAction(actionTypes.UPLOAD_CSV);
export const uploadCSVSuccess = createAction(actionTypes.UPLOAD_CSV_SUCCESS);
export const uploadCSVFailure = createAction(actionTypes.UPLOAD_CSV_FAILURE);

export const deleteAbsence = createAction(actionTypes.DELETE_ABSENCE_REQUEST);
export const deleteAbsenceSuccess = createAction(actionTypes.DELETE_ABSENCE_SUCCESS);
export const deleteAbsenceFailure = createAction(actionTypes.DELETE_ABSENCE_FAILURE);
